import { Typography, Box, Button } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useHomeDestination } from '@hooks/useHomeDestination';

function NotFoundPage() {
  const { t } = useTranslation();
  const home = useHomeDestination();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '50vh',
        textAlign: 'center',
      }}
    >
      <Typography variant="h1" component="h1" gutterBottom>
        {t('pages.notFound.code')}
      </Typography>
      <Typography variant="h4" component="h2" gutterBottom>
        {t('pages.notFound.title')}
      </Typography>
      <Typography variant="body1" color="text.secondary" paragraph>
        {t('pages.notFound.message')}
      </Typography>
      <Button component={RouterLink} to={home.to} variant="contained" color="primary" size="large">
        {home.signedIn ? t('pages.notFound.returnHome') : t('common.signIn')}
      </Button>
    </Box>
  );
}

export default NotFoundPage;
